import type { SignatureInput, SignaturePayload, DocumentCompletion } from '../../shared/types';
import type { PdfSignatureContext } from '../../shared/pdfBindings';
export function signaturePayload(signature: SignatureInput): SignaturePayload {
  return signature.kind === 'typed' ? signature : { kind: 'drawn', pngBase64: btoa(Array.from(signature.png, b => String.fromCharCode(b)).join('')) };
}
export function signatureAppearance(payload?: SignaturePayload): SignatureInput | null {
  if (!payload) return null;
  if (payload.kind === 'typed') return payload;
  if (payload.pngBase64.length > 180_000) return null;
  try { return { kind: 'drawn', png: Uint8Array.from(atob(payload.pngBase64), b => b.charCodeAt(0)) }; } catch { return null; }
}
export function completionSignatures(completion: DocumentCompletion): PdfSignatureContext {
  const signatures: PdfSignatureContext = {};
  for (const role of ['participant', 'parent'] as const) {
    if (!completion.confirmedSignatureRoles.includes(role)) continue;
    const signature = signatureAppearance(role === 'participant' ? completion.participantSignature : completion.parentSignature), signedOn = completion.signedDates[role];
    if (signature && signedOn) signatures[role] = { signature, signedOn };
  }
  return signatures;
}
